import { Navbar1 } from "components/navbars";
import Contact from "crm/other/Contact";
import { Footer1 } from "components/footer";
import Seo from "components/Seo";
import BackToTop from "components/BackToTop";
import { usePageTracking } from "helpers/usePageTracking";

export default function ContactPage() {
    const seo = usePageTracking("contact");
    return (
        <>
            {seo && (
                <Seo
                    pageName="contact"
                    title={seo.pageTitle}
                    description={seo.seoMetaDescription}
                    keywords={seo.seoMetaKeywords}
                    url="https://salestrackify.com/contact"
                    image="/seo/trackify-preview.png"
                />
            )}

            <Navbar1
                hideSearch
                fixedWidth
                navClass="navbar-light zindex-10"
                buttonClass="btn-outline-secondary btn-sm"
            />
            <Contact />

            <Footer1 />
            <BackToTop />
        </>
    );
}
